module.exports = __webpack_public_path__ + "img/desserts.14dd13d4.png";